// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiFacility {
    static getAttributeTypeMap() {
        return MedicalBiFacility.attributeTypeMap;
    }
}
MedicalBiFacility.discriminator = undefined;
MedicalBiFacility.additionalProperties = false;
MedicalBiFacility.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "address",
        "baseName": "address",
        "type": "MedicalBiAddress"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
    {
        "name": "fax",
        "baseName": "fax",
        "type": "string"
    },
];
//# sourceMappingURL=medicalBiFacility.js.map